import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationIntervalService {

    public bookingInfo;
    public vendorAssignmentInfo;
    public cabAssignmentInfo;
    private notificationConfig$ = new BehaviorSubject({});
    public notificationConfigObs = new Observable<any>();
    private filteredCreateBookingList$ = new Subject();
    public filteredCreateBookingListObs = new Observable<any>();
    private filteredVendorAcceptanceList$ = new Subject();
    public filteredVendorAcceptanceListObs = new Observable<any>();
    private filteredCabAllocationList$ = new Subject();
    public filteredCabAllocationListObs = new Observable<any>();
    public logoutSubject$ = new Subject();
    constructor(
      private apiService: ApiService,

      ) {
        this.notificationConfigObs = this.notificationConfig$.asObservable();
        this.filteredCreateBookingListObs = this.filteredCreateBookingList$.asObservable();
        this.filteredVendorAcceptanceListObs = this.filteredVendorAcceptanceList$.asObservable();
        this.filteredCabAllocationListObs = this.filteredCabAllocationList$.asObservable();
      }

    updateFilteredBookingList(bookings) {
      this.filteredCreateBookingList$.next(bookings);
    }

    updateFilteredVendorList(bookings) {
      this.filteredVendorAcceptanceList$.next(bookings);
    }

    updateFilteredCabAllocList(bookings) {
      this.filteredCabAllocationList$.next(bookings);
    }

    fetchNotificationInfo(request) {
        return this.apiService.httpRequest({
          url: 'fetchNotificationInfo',
          type: 'POST',
          body: request
        });
    }

    setNotificationConfig(value) {
      this.notificationConfig$.next(value);
    }

    setBookingCreationInfo(value) {
      this.bookingInfo = value;
    }

    setVendorAssignmentInfo(value) {
      this.vendorAssignmentInfo = value;
    }

    setCabAssignmentInfo(value) {
      this.cabAssignmentInfo = value;
    }

    fetchNotificationConfig(queryParams) {
      return this.apiService.httpRequest({
        url: 'fetchNotificationConfig',
        type: 'GET',
        queryParams,
      });
    }

    setBookingInfoStorage(info) {
      localStorage.setItem("lastUpdatedTimebookingCreation", JSON.stringify(info));
    }

    setVendorInfoStorage(info) {
      localStorage.setItem("lastUpdatedTimeVendorAcceptance", JSON.stringify(info));
    }

    setCabAllocationInfoStorage(info) {
      localStorage.setItem("lastUpdatedTimeCabAllocation", JSON.stringify(info));
    }

    clearAllDateForNotification() {
      this.logoutSubject$.next(true);
      localStorage.clear();
      this.bookingInfo = [];
      this.vendorAssignmentInfo = [];
      this.cabAssignmentInfo = [];
    }
}
